import { render, staticRenderFns } from "./MailErrorsDialog.vue?vue&type=template&id=39066bb4&"
import script from "./MailErrorsDialog.vue?vue&type=script&lang=js&"
export * from "./MailErrorsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MailErrorsDialog.vue"
export default component.exports